module.exports = __webpack_public_path__ + "static/media/mindset.9ee37701.png";